import { createContext, useState } from 'react';

export const AnswersContext = createContext(null);

export const AnswersProvider = ({ children }) => {
  const [answeredQuestions, setAnsweredQuestions] = useState([]) 
  const [currentPageAnswers, setCurrentPageAnswers] = useState([])

  return (
    <AnswersContext.Provider value={{
      answeredQuestions, setAnsweredQuestions,
      currentPageAnswers, setCurrentPageAnswers
    }}>
      {children}
    </AnswersContext.Provider>
  )
}